module.exports = __webpack_public_path__ + "static/img/voucher-add.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/voucher-add.png
// module id = 179
// module chunks = 0